<template>
  <div class="down-payment-box" :class="[{ mobile: isMobile() }, version]">
    <div
      @click="onClick"
      :class="[
        'down-payment-inner-box',
        isActiveClass,
        {'cursor-pointer': !isMobile(), mobile: isMobile() }
      ]"
      v-apply-theme
    >
      <asset-v3
        v-if="active && version !== 'v2'"
        dir="icons"
        :class="[{ mobile: isMobile() }, 'down-payment-check-icon']"
        name="check-small.svg"
      />

      <div class="down-payment-box-title" :class="[{mobile: isMobile() }, version]">
        {{ downPaymentPercentage | downPaymentText }}

        <div
          v-if="version === 'v2'"
          :class="{active}"
          class="circle-check"
        >
          <div v-if="active" class="inner-circle"/>
        </div>
      </div>
      <div
        :class="[
          'down-payment-box-value',
          active ? 'down-payment-box-value--active' : '',
          {
            skeleton: loadingValues,
            mobile: isMobile(),
            invisible: downPaymentValue === 0
          }
        ]"
        v-apply-theme
      >
        {{ downPaymentValue | moneyFilter }}
      </div>
      <div v-if="isMobile() && economyValue > 0"
        class="down-payment-inner-box-economy"
        :class="{ 'has-economy': economyValue > 0 }"
      >
        Economize até {{ economyValue | moneyFilter }}
      </div>
      <div
        :class="[
          'down-payment-box-expiration',
          { mobile: isMobile(), invisible: downPaymentPercentage === 0 },
        ]"
        v-apply-theme
      >
        Vencimento 1 dia útil
      </div>
    </div>
    <div v-if="!isMobile() && economyValue > 0" class="down-payment-box-economy">
      Economize até
    </div>
    <div
      v-if="!isMobile() && economyValue > 0"
      class="down-payment-box-economy-value"
      v-apply-theme
    >
      {{ economyValue | moneyFilter }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import StringMixin from '@/mixins/string';
import UtilMixin from '@/mixins/util';
import CheckoutMixin from '@/feature/checkout/checkout.mixin';
import AssetV3 from '@/components/common/AssetV3.vue';
import { ApplyTheme } from '../../directives/applyTheme';

export default {
  name: 'down-payment-box',
  components: { AssetV3 },
  directives: {
    ApplyTheme,
  },
  computed: {
    ...mapState('theme', ['theme']),
    isActiveClass() {
      return this.active ? 'active' : '';
    },
  },
  methods: {
    onClick(evt) {
      this.$emit('click', evt);
    },
  },
  mixins: [StringMixin, CheckoutMixin, UtilMixin],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    downPaymentValue: {
      type: Number,
      required: true,
    },
    downPaymentPercentage: {
      type: Number,
      required: true,
    },
    economyValue: {
      type: Number,
      default: null,
    },
    loadingValues: {
      type: Boolean,
      default: false,
    },
    version: {
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
.invisible {
  display: none;
}

.down-payment-inner-box-economy {
  font-size: 14px;
  @extend .x-small-semibold;
  position: absolute;
  color: var(--gray-500);
  &.has-economy{
    color: var(--primary);
  }
}

.down-payment-check-icon {
  position: absolute;
  right: 4px;
  top: 4px;

  &.mobile {
    right: 12px;
    top: 12px;
  }

  &--vivo {
    display: none;
  }
}

.down-payment-box {
  display: flex;
  flex-direction: column;
  flex: 1;

  &.mobile {
    width: 100%;
  }

  &.v2 {
    width: 100%;
  }
}

.down-payment-box-title {
  @extend .x-small-regular;
  @extend .gray-600;

  &.mobile {
    @extend .small-regular;
  }

  &.v2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--primary);
  }
}

.down-payment-box-value {
  @extend .small-semibold;
  @extend .gray-700;
  padding: 4px 0;
  &.mobile {
    @extend .body-bold;
  }
}
.down-payment-box-value--active {
  &--vivo {
    color: var(--primary);
  }
}
.down-payment-box-expiration {
  @extend .x-small-regular;
  @extend .gray-500;

  &.mobile {
    float: right;
  }
  &--vivo {
    color: var(--gray-300);
    white-space: nowrap;
  }
}

.down-payment-box-economy {
  @extend .x-small-regular;
  @extend .gray-500;
  text-align: center;
  padding-top: 4px;
}

.active.mobile > .down-payment-inner-box-economy {
  color: var(--primary);
}

.down-payment-box-economy-value {
  @extend .small-semibold;
  @extend .primary;
  text-align: center;
  &--vivo {
    font-weight: normal;
  }
}

.down-payment-inner-box {
  min-height: 60px;
  background: var(--white);
  border: 1px solid var(--gray-200);
  border-radius: 8px;
  padding: 12px;
  margin: 4px 0px;
  position: relative;
  cursor: pointer;
  &.mobile {
   min-height: 0px;
  }

  &:hover {
    border: 1px solid var(--primary);
  }

  &.active {
    background-color: var(--primary-extra-light);
    border: 1px solid var(--primary);
    &--vivo {
      border: 1px solid var(--primary);
      background-color: var(--white);
    }
  }

  &--vivo {
    margin-right: 8px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    &.mobile {
      display: initial;
    }
  }
}

.circle-check {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  background-color: var(--gray-100);
  border-radius: 50%;
  border: 1px solid var(--gray-300);

  .inner-circle {
    background-color: var(--white);
    border-radius: 50%;
    width: 8px;
    height: 8px;
  }

  &.active {
    background-color: var(--primary);
    border: none;
  }
}

</style>
